module.exports = __webpack_public_path__ + "static/media/001-IN_1.d99a8c54.PDF";